class Plugin {
  initialize(/* configuration, props */) {
  }

  createServices(/* configuration, services */) {
  }

  configurationInitialized(/* configuration, props */) {
  }

  initializeRoutes(/* routeService, configuration, props */) {
  }

  registerComponents(/* viewService */) {
  }

  registerIcons(/* viewService */) {
  }

  registerValidators(/* viewService, configuration, props */) {
  }

  registerFormatters(/* viewService, configuration, props */) {
  }

  registerEditors(/* viewService, configuration, props */) {
  }

  registerComputedProperties(/* viewService, configuration, props */) {
  }

  registerViewHooks(/* viewService, configuration, props */) {
  }
}

export default Plugin;
